import React, { AriaAttributes, memo } from 'react';
import { cx } from 'linaria';
import { Typography, useUniqID } from 'fronton-react';
import {
  suggestionsList,
  suggestionsFieldset,
  suggestionsTitle,
  suggestionsWrapper,
  dividerTop,
  dividerBottom,
} from './suggestion-list-styles';

type SuggestionsListProps = React.PropsWithChildren<{
  withTitle: boolean;
  withDivider?: boolean;
  title: string;
  suggestionSelector: string;
  'data-qa': string;
}> &
  AriaAttributes;

export const SuggestionsList: React.FC<SuggestionsListProps> = memo((props) => {
  const {
    withTitle,
    suggestionSelector,
    title,
    'aria-label': label,
    children,
    withDivider = false,
    'data-qa': dataQA,
  } = props;
  const count = React.Children.count(children);
  const titleId = useUniqID();

  if (count === 0) return null;

  const groupAriaLabelledBy = withTitle && !label ? titleId : undefined;

  return (
    <div
      className={cx(
        suggestionsWrapper,
        suggestionSelector,
        withDivider && dividerTop,
        withDivider && dividerBottom,
      )}
    >
      {withTitle ? (
        <Typography
          variant="minor"
          size="overline"
          id={titleId}
          className={cx(suggestionsTitle, suggestionSelector)}
        >
          {title}
        </Typography>
      ) : null}
      <fieldset
        aria-label={label}
        aria-labelledby={groupAriaLabelledBy}
        className={cx(suggestionsFieldset, withTitle && suggestionsList, suggestionSelector)}
        data-qa={dataQA}
      >
        {children}
      </fieldset>
    </div>
  );
});
